export default function Tooltip(theme) {
  return {
    MuiTooltip: {
      defaultProps: {
        arrow: false,
      },
      styleOverrides: {
        tooltip: {
          backgroundColor: theme.palette.grey[900],
          color: theme.palette.common.white,
          fontSize: theme.typography.pxToRem(12),
          fontWeight: 500,
          padding: theme.spacing(0.75, 1.25),
          borderRadius: 6,
          boxShadow: theme.customShadows.z8,
        },
        arrow: { color: theme.palette.grey[900] },
      },
    },
  };
}
